import { ReactComponent as ValIcon } from "assets/icons/ErrorIcon.svg";
import styled from "styled-components";

export const TicketWrapper = styled.div`
    margin-top: 30px;
    background-color: #FFFFFF;
    color: var(--font-color-blackalpha87);
    position: relative;
    overflow-anchor: none;
    border-radius: 10px;
    box-shadow: 0px 14px 60px 0px rgba(22, 16, 59, 0.05);
    -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    -webkit-transition: margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    padding: 20px !important;
`
export const TicketName = styled.h1`
  color: var(--font-color-blue002e5c);
  font-size: var(--general-sub-header-font-size);
  font-weight: var(--general-sub-header-font-weight);
`
export const TicketTitle = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
align-items: center;
`
export const DeleteTicket = styled.button`
display: flex;
justify-content: center;
align-items: normal;
color: var(--font-color-blue007bff);
font-size: var(--general-caption-font-size);
font-weight: var(--general-caption-font-weight);
border: 0;
background-color: transparent;
border-right:1px solid rgba(0, 46, 92, 0.05); 
margin-right: 10px;
padding-right: 10px;
align-items: center;
svg{
    margin-right: 5px;
}
`
export const DashLine = styled.hr`
  border-top: dashed 1px #002E5C;
  opacity: 0.1;
  width: 90%;
`
export const SolidLine = styled.hr`
  border-top: solid 1px #002E5C;
  opacity: 0.1;
  width: 100%;
`
export const TicketContent = styled.div`
 padding-top: 30px;
 padding-left:40px ;
 padding-right:40px;
 width: 100%;
 @media only screen and (min-width: 280px) and (max-width: 767px) {
  padding-left:0px ;
  }
`
export const ProductWrapper = styled.div`
h3{
  color: var(--font-color-blue002e5c);
font-family: var(--general-header-font-family);
font-size: var(--general-header-font-size);
font-style: normal;
font-weight: var(--font-weight-regular);
line-height: normal;  
opacity: 0.7;
@media only screen and (min-width: 280px) and (max-width: 767px) {
  margin-top: auto;
  }
}

`
export const ValidationWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--Pink-20, #FFE5ED);
  background: var(--Pink-10, #FFF5F8);
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 30px;
`
export const ValidationItems = styled.ul`
  color:var(--font-color-blue002e5c);
  padding-top: 8px;

  li{

  }
`
export const ValidationIcon = styled(ValIcon)`
  

`

export const TicketOptionsHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 40px;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;

export const TicketOptionsSelection = styled.div`
  width: 50%;
  @media only screen and (min-width: 280px) and (max-width: 767px) {
    width: 100%;
  }

`;

export const BulkTicketWrapper = styled.div`
padding:28px 33px 0px 33px;
height: 100%;
display: flex;
justify-content: flex-start;
align-items: flex-start;
flex-direction: column;
`

export const BulkTicketWrapperTitle = styled.div`
color: var(--font-color-blue002e5c);
font-size: var(--general-header-font-size);
font-style: normal;
font-weight: var(--general-header-font-weight);
line-height: 32px;
padding-bottom: 8px;
display: flex;
justify-content: space-between;
align-items: center;
border-bottom: 1px dashed rgba(0, 46, 92, 0.10);
width: 100%;
margin-bottom: 24px;
span{
padding-right: 8px;
}
`

export const BulkTicketForm = styled.div`
  padding: 0 33px;
`